import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({ title, description, url, image }) => {
  const defaultTitle = "SHALL Social and Development Organization";
  const defaultDescription =
    "SHALL is committed to empowering communities through sustainable solutions, education, and innovation.";
  const defaultImage = "https://shallafg.org/logo512.png";
  const defaultUrl = "https://shallafg.org/";

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "SHALL Social and Development Organization",
    url: "https://shallafg.org/",
    logo: "https://shallafg.org/logo512.png",
    sameAs: [
      "https://www.facebook.com/shallafg",
      "https://twitter.com/shallafg",
    ],
    description:
      "SHALL is committed to empowering communities through sustainable solutions, education, and innovation.",
  };

  return (
    <Helmet>
      <title>{title ? `${title} | SHALL` : defaultTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <link rel="canonical" href={url || defaultUrl} />

      {/* OpenGraph metadata for social sharing */}
      <meta property="og:title" content={title || defaultTitle} />
      <meta
        property="og:description"
        content={description || defaultDescription}
      />
      <meta property="og:url" content={url || defaultUrl} />
      <meta property="og:image" content={image || defaultImage} />
      <meta property="og:type" content="website" />

      {/* Twitter Card metadata */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || defaultTitle} />
      <meta
        name="twitter:description"
        content={description || defaultDescription}
      />
      <meta name="twitter:image" content={image || defaultImage} />

      {/* Schema.org JSON-LD for structured data */}
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
};

export default SEO;
